import { organizationConstants } from '../constants'

const initialState = {
  loading: false,
  error: null,
  current: null,
  list: null,
  count: 0,
  init: false,
  updating: false
}

export default function organization(state = initialState, action) {
  switch (action.type) {
    case organizationConstants.ORGANIZATION_LOAD:
      return {
        ...state,
        loading: true,
        current: null,
        init: true
      }
    case organizationConstants.ORGANIZATION_JOIN:
      return {
        ...state,
        loading: true
      }
    case organizationConstants.ORGANIZATION_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list.sort((a, b) => a.name.localeCompare(b.name)),
        count: action.payload.count
      }
    case organizationConstants.ORGANIZATION_JOIN_SUCCESS:
    case organizationConstants.ORGANIZATION_SAVE_SUCCESS:
      const list = (
        state.list.find((x) => x._id === action.payload._id)
          ? state.list.map((x) => {
              return x._id === action.payload._id ? action.payload : x
            })
          : [...state.list, action.payload]
      ).sort((a, b) => a.name.localeCompare(b.name))
      return {
        ...state,
        updating: false,
        loading: false,
        list,
        count: list.count
      }
    case organizationConstants.ORGANIZATION_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case organizationConstants.ORGANIZATION_SAVE:
      return {
        ...state,
        updating: true
      }
    case organizationConstants.ORGANIZATION_JOIN_FAILURE:
    case organizationConstants.ORGANIZATION_SAVE_FAILURE:
      return {
        ...state,
        updating: false,
        loading: false,
        error: action.payload
      }
    case organizationConstants.ORGANIZATION_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
